// Components
import { Box, Button, ButtonGroup, HStack, ModalBody, ModalFooter, Stack, Text, useDisclosure, useToast } from "@chakra-ui/react"
import { Form, Icon, Lottie, Modal, Pressable, Section } from "components"
import { API } from "config"
import { Mask } from "config"

// Hookes
import { useOrder, useShipments } from "hooks"
import { useRef, useState } from "react"

export default function Collect({ data, ...props }){

    const order = useOrder(data?.id)
    const confirm = useDisclosure()

    return(
    <>
    <Stack p={10}>
        <Section title="Informações para coleta" mt={0} />
        <Item icon="transit" title="Imprimir Etiqueta de envio" description={<>Etiqueta da Bonífica gerada automaticamente.</>} onClick={() => window.open(order.data?.label_url)} />

        <Button children="Confirmar coleta da transportadora" colorScheme="orange" size="lg" onClick={confirm.onOpen} />
    </Stack>

    <Confirm {...confirm} data={order.data} onSuccess={order.refetch} />
    </>
    )
}

const Item = ({ title, description, icon, ...props }) => {
    return(
    <Pressable {...props}>
        <Box py={4} px={4} borderWidth={3} borderRadius={8}>
            <HStack alignItems="center" spacing={6}>
                <Icon name={icon} width={30} height={30} />
                <Box>
                    <Text fontWeight="bold" children={title} />
                    <Text fontSize="sm" color="GrayText" children={description} />
                </Box>
            </HStack>
        </Box>
    </Pressable>
    )
}

const Confirm = ({ data, onSuccess = () => {}, ...props }) => {

    const toast = useToast()
    const submitRef = useRef()
    const [ shipment_id, setShipment ] = useState(data?.shipment_id)
    const [ shipping_amount, setAmount ] = useState(Mask.price(data?.shipping_amount))
    const [ shipping_track_code, setShippingTrackCode ] = useState()   
    const shipments = useShipments()
    const [ loading, setLoading ] = useState(false)
    const [ errors, setErrors ] = useState(false)

    const handleSubmit = async () => {
        if(!window.confirm("Tem certeza que deseja despachar este pedido?")) return
        setLoading(true)

        try{
            await API.post(`/orders/${data.id}/collect`, { shipping_track_code, _method: 'put' })
            toast({ title: 'O pedido foi coletado com sucesso!', status :'success' })
            props.onClose()
            onSuccess()
        }catch(err){
            toast({ title: 'Não foi possível continuar', description: err?.response?.data?.message, status :'warning'})
            setErrors(err?.response?.data?.errors)
        }

        setLoading(false)
    }

    return(
    <Modal title="Confirmar coleta pela transportadora" {...props}>
        <ModalBody fontSize="sm">

            <Lottie animation="shipping" style={{ width: 200 }} options={{ loop: true }} />
            
            Confirme os dados da transportadora e do serviço utilizado antes de continuar. A seguir, clique em "Confirmar Coleta".

            <Form.Form mt={6} onSubmit={handleSubmit} submitRef={submitRef}>

                <Form.Select 
                    required
                    label="Tipo de serviço:"
                    value={shipment_id}
                    options={shipments.data?.map(item => ({ label: item.label, value: item.id }))}
                    onChange={e => setShipment(e.target.value)}
                    isDisabled={loading}
                    error={errors?.shipment_id}
                    disabled
                />

                <Form.Text
                    required
                    label="Valor:"
                    leftAddon="R$"
                    value={shipping_amount}
                    onChange={e => setAmount(Mask.price(e.target.value))}
                    isDisabled={loading}
                    error={errors?.amount}
                    disabled
                />

                <Form.Text
                    label="Código de rastreio:"
                    vale={shipping_track_code}
                    onChange={e => setShippingTrackCode(e.target.value)}
                    placeholder="Ex.: BRDNJSNB839379"
                    textTransform="uppercase"
                    size="lg"
                    fontWeight="bold"
                    helper="O código de rastreio é informado pela transportadora e é opcional."
                    isDisabled={loading}
                />

            </Form.Form>
        </ModalBody>

        <ModalFooter>
            <ButtonGroup size="sm">
                <Button children="Confirmar coleta" colorScheme="orange" isLoading={loading} onClick={() => submitRef.current?.click()} />
                <Button children="Cancelar" onClick={props.onClose} />
            </ButtonGroup>
        </ModalFooter>
    </Modal>
    )
}